import styled from "styled-components";

import { color } from "@runwayhealth/runway-components-react";

export const GatewayCard = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid
    ${(props) => (props.$selected ? color.brand.primary.medium : color.brand.secondary.light)};
  background: ${(props) =>
    props.$selected ? color.brand.primary.lighter : color.neutral.lightest};
  border-radius: 16px;
  padding: 22px 24px 20px 24px;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover {
    background-color: ${color.brand.primary.lighter};
    border: 2px solid ${color.brand.primary.medium};
  }
`;
